import { render, staticRenderFns } from "./create-report-with-object-button.vue?vue&type=template&id=0fee5c54&"
import script from "./create-report-with-object-button.vue?vue&type=script&lang=ts&"
export * from "./create-report-with-object-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports